import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { CircularProgress, Container, Fade, Typography } from "@mui/material";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import './campaignContact.css';
import { useTranslation } from 'react-i18next';
import { requestCampaign } from '../../reducers/myDesigns/myDesignsThunks';

const PREFIX = 'CampaignContact';

const classes = {
  goldenTypo: `${PREFIX}-goldenTypo`,
  subTitle: `${PREFIX}-subTitle`,
  buttonSend: `${PREFIX}-buttonSend`
};

const StyledDiv = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.goldenTypo}`]: {
    color: 'rgb(211, 175, 95)',
    textAlign: 'left',
    margin: '1rem 0 1.5rem 0',
    fontSize: '20px',

    [theme.breakpoints.between('xs', 'md')]: {
      textAlign: 'start',
    },
  },

  [`& .${classes.subTitle}`]: {
    marginBottom: '0.5rem',
  },

  [`& .${classes.buttonSend}`]: {
    marginTop: '1rem',
  }
}));

export default function CampaignContact(props) {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const loading = useSelector(state => state.myDesigns.loading)

  const dispatch = useDispatch();
  const [inputs, setInputs] = useState({
    radioChoice: 'email',
    cellphoneNumber: '',
    mailContent: '',
  });
  const { radioChoice, mailContent, cellphoneNumber } = inputs;

  function handleChange(e) {
    const { name, value } = e.target;
    setInputs(inputs => ({ ...inputs, [name]: value }));
  }

  function handleChangeCellphone(phone) {
    setInputs(inputs => ({ ...inputs, cellphoneNumber: phone }));
  }

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      const thunk = await dispatch(requestCampaign({
        campaignForm: {
          mailContent: mailContent,
          cellphoneNumber: cellphoneNumber,
        },
        targetId: props.frameId
      }));
      if (thunk.meta.requestStatus === "rejected")
        throw new Error("recovery error");
      setInputs({
        radioChoice: 'email',
        cellphoneNumber: '',
        mailContent: '',
      })
      enqueueSnackbar(t('toasts.askNewCampaignForm'), { variant: 'success' })
    } catch (err) {
      enqueueSnackbar(t('toasts.unknownError'), { variant: 'error' })
    }
  }

  return (
    <StyledDiv>
      <Container className={classes.mainContainer}>
        <Typography variant="h5" className={classes.goldenTypo}>
          {t('myDesign.campaignForm.contactTitle').toUpperCase()}
        </Typography>
        <form noValidate onSubmit={handleSubmit}>
          <Typography variant="body1" className={classes.subTitle}>
            {t('myDesign.campaignForm.contactWay')}
          </Typography>
          <RadioGroup aria-label="contact-choice" name="radioChoice" value={radioChoice} onChange={handleChange}>
            <FormControlLabel value="email" control={<Radio
            sx={{
              color: 'rgba(211, 175, 95, 0.8)',
              '&.Mui-checked': 'rgba(211, 175, 95, 1)'
            }} />} label={t('myDesign.campaignForm.emailWay')} />
            <FormControlLabel value="phone" control={<Radio
              sx={{
                color: 'rgba(211, 175, 95, 0.8)',
                '&.Mui-checked': 'rgba(211, 175, 95, 1)'
              }} />} label={t('myDesign.campaignForm.cellphoneWay')} />
            {radioChoice === "phone" &&
              <Fade in={radioChoice === "phone"} timeout={1200}>
                <PhoneInput
                  country={'fr'}
                  value={cellphoneNumber}
                  onChange={phone => handleChangeCellphone(phone)}
                  dropdownStyle={{
                    backgroundColor: '#303030',
                  }}
                  searchStyle={{
                    backgroundColor: '#303030',
                  }}
                  buttonStyle={{
                    backgroundColor: '#303030',
                  }}
                  inputStyle={{
                    backgroundColor: '#303030',
                  }}
                  containerStyle={{
                    backgroundColor: '#303030',
                  }}
                />
              </Fade>
            }
          </RadioGroup>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            rows={4}
            multiline
            id="mailContent"
            label={t('myDesign.campaignForm.specifyRequest')}
            name="mailContent"
            value={mailContent}
            autoComplete="mailContent"
            onChange={handleChange}
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={classes.buttonSend}
            disabled={(radioChoice === "email" && mailContent.length === 0) ||
              (radioChoice === "phone" && (cellphoneNumber === "" || mailContent.length === 0))}
          >
            {loading ? <CircularProgress size={28} /> : t('myDesign.campaignForm.sendButton')}
          </Button>
        </form>
      </Container>
    </StyledDiv>
  );
}
